






















































import { Component, Vue } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import DpSelect from '@/components/atoms/DpSelect/index.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';

@Component({
  name: 'MarketEstimatePotentialIncomeWidget',
  components: {
    SvgIcon,
    DpSelect,
    DpButton,
  },
})
export default class MarketEstimatePotentialIncomeWidget extends Vue {
  protected show: boolean = true;

  protected form: any = {
    type: 'apartment',
    bedroomCount: 1,
  };

  protected typeItems: any = [
    {
      value: 'apartment',
      label: 'Apartment',
    },
  ];

  protected bedroomCountItems: any = [
    {
      value: 1,
      label: 1,
    },
    {
      value: 2,
      label: 2,
    },
  ];

  protected toggle() {
    this.show = !this.show;
  }
}
